// MobileWelcomeModal.jsx
import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Button,
  Text,
  Box,
  VStack,
  Center,
  List,
  ListItem,
  Flex,
} from "@chakra-ui/react";
import { modalStyles } from "./WelcomeModal.styles";
import WelcomeLottie from "../../../assets/onboardingVin.gif";
import { useRoot } from "../../../context/RootContext";
const MobileWelcomeModal = ({ isOpen, onClose, name }) => {
  const { setDisplayProductTour } = useRoot();
  const styles = modalStyles;
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay bg="rgba(0,0,0,0.3)" />
      <ModalContent bg="white" h={"100%"}>
        <VStack {...styles.headerMobile}>
          <Box style={styles.lottieBoxMobile}>
            <img
              src={WelcomeLottie}
              alt="Error Image"
              style={{
                width: "200%",
                height: "150%",
                maxWidth: "100%",
                margin: "0 auto",
              }}
            />
          </Box>
        </VStack>

        <ModalBody p={6}>
          {/* Content */}
          <Text {...styles.welcomeTextMobile}>Hi {name}! I'm Vin</Text>
          <Box {...styles.contentContainerMobile}>
            <Text {...styles.listItemTextMobile}>
              Let’s get started with a quick product tour. Explore the various
              features to check your homework list, class updates, and syllabus
              progress. You’ll be up and running soon!
            </Text>
          </Box>

          {/* Buttons */}
          <Flex {...styles.buttonContainerMobile}>
            <Button {...styles.skipButtonMobile} onClick={onClose}>
              Skip the tour
            </Button>
            <Button
              {...styles.nextButtonMobile}
              onClick={() => {
                onClose();
                setDisplayProductTour(true);
              }}
            >
              Quick Tour
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default MobileWelcomeModal;
